var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pinsData.length > 0)?_c('div',{staticClass:"organism-pins"},_vm._l((_vm.pinsData),function(pin,index){return _c('MoleculesProjectMoleculePin',{key:index,ref:"pinRef",refInFor:true,attrs:{"pin-data":pin,"expanded":index === _vm.expandedPin,"on-close":_vm.handlePinClose,"on-expand":() => {
        _vm.handlePinExpand(index)
      }}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }